import React from "react";
import { Create, useForm } from "@refinedev/antd";
import { Form } from "antd";
import { useResource } from "@refinedev/core";
import type { FieldDef } from "@evo-flywheel/contracts";
import { resourceBySlug } from "../../kit-resources";
import { FormField } from "../../fields";

export const GenericCreate: React.FC = () => {
  const { resource } = useResource();
  const meta = resourceBySlug[resource?.name ?? ""]?.meta;
  const { formProps, saveButtonProps } = useForm();

  const fieldMap = new Map<string, FieldDef>(
    (meta?.fields ?? []).map((f) => [f.name, f])
  );
  const view = meta?.createView;
  const required = new Set(view?.required ?? []);
  const defaults = view?.defaults ?? {};

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        {(view?.fields ?? []).map((name) => {
          const field = fieldMap.get(name);
          if (!field) return null;
          return (
            <FormField
              key={name}
              field={field}
              required={required.has(name)}
              initialValue={defaults[name]}
            />
          );
        })}
      </Form>
    </Create>
  );
};
